import { createLazyFileRoute } from "@tanstack/react-router"

import MarketItemPage from "#/pages/MarketItemPage"
import { routes } from "#/shared/constants"

export const Route = createLazyFileRoute(`${routes.MARKET_ITEM}`)({
  component: () => <MarketItemPage />,
})
